
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BookOpen, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate, useParams } from "react-router-dom";

interface NextTestCardProps {
  isLoading: boolean;
  nextTest?: {
    id: string;
    title: string;
    category: string;
    difficulty: string;
    grade_level: string;
  }[] | null;
}

export const NextTestCard = ({ isLoading, nextTest }: NextTestCardProps) => {
  const navigate = useNavigate();
  const { id: childId } = useParams();
  const nextSingleTest = nextTest && nextTest.length > 0 ? nextTest[0] : null;

  const handleStartTest = () => {
    if (nextSingleTest && childId) {
      // Store the childId in localStorage before navigation
      localStorage.setItem("selectedChildId", childId);
      navigate(`/test/${nextSingleTest.id}`);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center text-lg">
          <BookOpen className="mr-2 h-5 w-5 text-primary" />
          Your Next Test
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <p className="text-gray-600">Loading next test...</p>
        ) : nextSingleTest ? (
          <div className="p-4 rounded-lg bg-accent/5">
            <div className="space-y-3">
              <h3 className="text-lg font-semibold text-primary">
                {nextSingleTest.category}
              </h3>
              <p className="font-medium">
                {nextSingleTest.grade_level} - {nextSingleTest.title}
              </p>
              <Button
                className="w-full mt-4"
                onClick={handleStartTest}
              >
                <Play className="h-4 w-4 mr-2" />
                Take Test
              </Button>
            </div>
          </div>
        ) : (
          <div className="text-center space-y-2">
            <p className="text-gray-600">All available tests completed!</p>
            <p className="text-sm text-muted-foreground">
              Great job! You've completed all the tests for your age level.
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
